import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IServiceInterfaceLogType } from "@/interfaces/service-interface.interface";
import serviceInterfaceLogService from "@/services/service-interface-log.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<IServiceInterfaceLogType[] | null>;

const useGetServiceInterfaceLogTypes = (): Return => {
  const fetcher = useSWR<IServiceInterfaceLogType[], Error>(
    SWR_KEYS.getServiceInterfaceLogTypes,
    () => serviceInterfaceLogService.getLogTypes(),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceInterfaceLogTypes;
